import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './panel.vdt';
import { useValue } from './useValue';
import { usePointer } from './usePointer';
import { useInput } from './useInput';
import { useConfigContext } from '../config';
export var ColorpickerPanel = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ColorpickerPanel, _Component);
  function ColorpickerPanel() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.value = useValue();
    _this.pointer = usePointer(_this.value.hsv, _this.value.format);
    _this.input = useInput(_this.value.hsv, _this.value.rgb, _this.value.hsl);
    _this.config = useConfigContext();
    return _this;
  }
  return ColorpickerPanel;
}(Component);
ColorpickerPanel.template = template;